import Icon from '../components/Icon.vue'

Icon.register({
  rainbow: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M268.3 32.7C115.4 42.9 0 176.9 0 330.2V464C0 472.8 7.2 480 16 480H48C56.8 480 64 472.8 64 464V320C64 186.8 180.9 80.3 317.5 97.9 430.4 112.4 512 214 512 327.8V464C512 472.8 519.2 480 528 480H560C568.8 480 576 472.8 576 464V320C576 154.7 436 21.4 268.3 32.7zM262.7 129.6C166 142 96 229.1 96 326.7V464C96 472.8 103.2 480 112 480H144C152.8 480 160 472.8 160 464V320C160 245.2 224.5 185.2 300.8 192.6 367.3 199.1 416 258.8 416 325.7V464C416 472.8 423.2 480 432 480H464C472.8 480 480 472.8 480 464V320C480 205.8 379.8 114.6 262.7 129.6zM268.9 225.9C223.3 234.8 192 277.4 192 323.8V464C192 472.8 199.2 480 208 480H240C248.8 480 256 472.8 256 464V320C256 302.4 270.3 288 288 288S320 302.4 320 320V464C320 472.8 327.2 480 336 480H368C376.8 480 384 472.8 384 464V320C384 260.8 330.2 214 268.9 225.9z'
      }
    ]
  }
})
